module.exports = __webpack_public_path__ + "static/media/Plus-Media-nova-mapa.672511fe.png";